import { multilevelCheckboxComponent } from './multilevel-checkbox.component';
import accordion from 'angular-ui-bootstrap/src/accordion';
import './multilevel-checkbox.scss';

export const multilevelCheckbox = angular
	.module('common.components.multilevel-checkbox', [
		accordion
		])
	.component('multilevelCheckbox', multilevelCheckboxComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/multilevel-checkbox/multilevel-checkbox.module.js